import { useMutation, useQueryClient } from '@tanstack/react-query';
import { bulkCancelSurveyJsQuizSession } from '~/pages/api/quizzes';
import { getQuizSessionsKey } from '../Sessions/useGetQuizSessions';

export type BulkCancelQuizSessionRequest = {
   quiz_sessionids: number[];
};

export type BulkCancelFailureRecord = {
   id: number;
   reason: string;
};

export type BulkCancelQuizSessionResponse = {
   cancelled_quiz_sessionids: number[];
   invalid_quiz_sessionids: BulkCancelFailureRecord[];
};

export function bulkCancelQuizSessionKey() {
   return ['bulk-cancel-quiz-session'];
}

export function useBulkCancelQuizSession() {
   const queryClient = useQueryClient();

   const mutationFunction = async ({
      quiz_sessionids,
   }: BulkCancelQuizSessionRequest): Promise<BulkCancelQuizSessionResponse> => {
      const result = await bulkCancelSurveyJsQuizSession(quiz_sessionids);

      queryClient.invalidateQueries({
         queryKey: [getQuizSessionsKey()],
      });

      return result;
   };

   return useMutation({
      mutationFn: mutationFunction,
      mutationKey: bulkCancelQuizSessionKey(),
   });
}
